import React from 'react'

import ContentBlock from '~/components/content-block'
import Modal from '~/components/modal'
import SpotLogo from '~/components/spot-logo'
import { i18n } from '~/i18n'

export type Props = {
  onClose: () => void
}

export default function InsuranceInfoModal({ onClose }: Props) {
  return (
    <Modal
      onClose={onClose}
      title={i18n.t('components.insurance_info_modal.title')}
      size="small"
      actions={{
        primary: {
          text: i18n.t('components.insurance_info_modal.learn_more'),
          onClick: () =>
            window
              .open(
                i18n.t('components.insurance_info_modal.learn_more_link'),
                '_blank',
              )
              .focus(),
        },
      }}
    >
      <ContentBlock>
        {i18n.t('components.insurance_info_modal.content_md')}
      </ContentBlock>
      <SpotLogo />
    </Modal>
  )
}
